import { Paper, Stack, Title, Button } from '@mantine/core';
import Text from '@ui/components/Text/Text';
import { useState } from 'react';

import TransferWorkspaceOwnershipModalContainer
	from 'src/containers/TransferWorkspaceOwnershipModalContainer/TransferWorkspaceOwnershipModalContainer';

const TransferWorkspaceOwnership = ( {
	workspaceID, canTransferOwnership
}: { workspaceID: number; canTransferOwnership: boolean; } ) => {
	const [ showingOwnershipModal, setShowingOwnershipModal ] = useState( false );

	const onOpenOwnershipModal = () => {
		setShowingOwnershipModal( true );
	};

	const onCloseOwnershipModal = () => {
		setShowingOwnershipModal( false );
	};

	return (
		<>
			{showingOwnershipModal && (
				<TransferWorkspaceOwnershipModalContainer
					// @ts-expect-error - TODO: fix this
					workspaceID={workspaceID}
					onClose={onCloseOwnershipModal}
				/>
			)}
			<Paper p={20} shadow="xs" style={{ background: 'var(--color-bg-container)' }}>
				<Stack spacing={20} justify="space-between" h="100%">
					<Stack spacing={14}>
						<Title order={4}>Transfer Ownership</Title>
						<Text>
							You are currently the Owner of this workspace.
							<br />
							Do you wish to transfer ownership to someone else?
						</Text>
					</Stack>
					<Stack align="end">
						<Button onClick={onOpenOwnershipModal} disabled={!canTransferOwnership}>
							Transfer Ownership
						</Button>
					</Stack>
				</Stack>
			</Paper>
		</>
	);
};

export default TransferWorkspaceOwnership;
